var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddTeamIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92 0c1.833 0 2.707.232 3.522.668a4.543 4.543 0 011.89 1.89c.436.815.668 1.689.668 3.522v1.84c0 1.833-.232 2.707-.668 3.522a4.543 4.543 0 01-1.89 1.89c-.815.436-1.689.668-3.522.668H6.08c-1.833 0-2.707-.232-3.522-.668a4.543 4.543 0 01-1.89-1.89C.232 10.627 0 9.753 0 7.92V6.08c0-1.833.232-2.707.668-3.522a4.543 4.543 0 011.89-1.89C3.373.232 4.247 0 6.08 0h1.84zm0 1H6.08c-1.55 0-2.316.157-3.05.55-.641.342-1.138.839-1.48 1.48-.393.734-.55 1.5-.55 3.05v1.84c0 1.55.157 2.316.55 3.05.342.641.839 1.138 1.48 1.48.734.393 1.5.55 3.05.55h1.84c1.55 0 2.316-.157 3.05-.55a3.543 3.543 0 001.48-1.48c.393-.734.55-1.5.55-3.05V6.08c0-1.55-.157-2.316-.55-3.05a3.543 3.543 0 00-1.48-1.48C10.237 1.157 9.47 1 7.92 1zM7.5 3a.5.5 0 01.5.5V6h2.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H8v2.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V8H3.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H6V3.5a.5.5 0 01.5-.5h1z",
    fill: "#596168",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTeamIcon);
export default ForwardRef;